import { createFileRoute } from '@tanstack/react-router'
import { LegalLayout } from '../features/legal/LegalLayout'

export const Route = createFileRoute('/_auth/legal')({
  component: LegalLayout,
})
